import { CheckOutlined } from '@ant-design/icons'

export function BooleanCell<T>(value: boolean, _record: T, _index: number): JSX.Element | null {
  if (!value) {
    return null
  }

  return <CheckOutlined className='text-xs text-gray-700' />
}
